import * as administrator from "./administrator";
import * as common from "./common";

const dele = {
  administrator,
  common,
};

export default dele;
